<template>
  <div class="contactdemo-container1">
    <app-navigation></app-navigation>
    <section id="demo-form-section" class="demo-form-section">
      <div class="demo-form-container">
        <div class="form-column">
          <div class="form-panel">
            <h2 class="section-title">
              {{ $t("contactDemo.hero.title") }}
            </h2>
            <p class="section-content">
              {{ $t("contactDemo.hero.description") }}
            </p>
            <div id="form-banner" role="alert" aria-live="polite" class="contactdemo-thq-form-banner-elm form-banner"></div>
            <form id="demo-form" @submit.prevent="handleSubmit" class="demo-form2">
              <div class="form-row2">
                <div class="form-group2">
                  <label for="form-name" class="form-label">{{ $t("contactDemo.form.labels.name") }}</label>
                  <input type="text" id="form-name" name="form-name" required="true" v-model="form.name" class="form-input1" />
                  <span id="error-name" class="form-error">
                    {{ $t("contactDemo.form.errors.name") }}
                  </span>
                </div>
                <div class="form-group2">
                  <label for="form-company" class="form-label">{{ $t("contactDemo.form.labels.company") }}</label>
                  <input type="text" id="form-company" name="form-company" required="true" v-model="form.company" class="form-input1" />
                  <span id="error-company" class="form-error">
                    {{ $t("contactDemo.form.errors.company") }}
                  </span>
                </div>
              </div>
              <div class="form-row2">
                <div class="form-group2">
                  <label for="form-email" class="form-label">{{ $t("contactDemo.form.labels.email") }}</label>
                  <input type="email" id="form-email" name="form-email" required="true" v-model="form.email" class="form-input1" />
                  <span id="error-email" class="form-error">
                    {{ $t("contactDemo.form.errors.email") }}
                  </span>
                </div>
                <div class="form-group2">
                  <label for="form-phone" class="form-label">{{ $t("contactDemo.form.labels.phone") }}</label>
                  <input type="tel" id="form-phone" name="form-phone" required="true" v-model="form.phone" class="form-input1" />
                  <span id="error-phone" class="form-error">
                    {{ $t("contactDemo.form.errors.phone") }}
                  </span>
                </div>
              </div>
              <div class="form-group2 full-width">
                <label class="form-label">{{ $t("contactDemo.form.labels.machinesUsed") }}</label>
                <div class="checkbox-row">
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-router" name="machines" value="router" v-model="form.machine_router" />
                    <span>{{ $t("contactDemo.form.machines.router") }}</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-nesting" name="machines" value="nesting" v-model="form.machine_nesting" />
                    <span>{{ $t("contactDemo.form.machines.nesting") }}</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-saw" name="machines" value="panel-saw" v-model="form.machine_saw" />
                    <span>{{ $t("contactDemo.form.machines.panelSaw") }}</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-edgebander" name="machines" value="edgebander" v-model="form.machine_edgebander" />
                    <span>{{ $t("contactDemo.form.machines.edgebander") }}</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" id="machine-other" name="machines" value="other" v-model="form.machine_other" />
                    <span>{{ $t("contactDemo.form.machines.other") }}</span>
                  </label>
                </div>
                <span id="error-machines" class="form-error">
                  {{ $t("contactDemo.form.errors.machines") }}
                </span>
              </div>
              <div class="form-group2 full-width">
                <label for="form-message" class="form-label">
                  {{ $t("contactDemo.form.labels.message") }}
                </label>
                <textarea id="form-message" name="form-message" rows="4" v-model="form.message" class="form-textarea1"></textarea>
              </div>
              <button name="button vn4pfnax1" type="submit" class="btn form-submit-btn btn-primary">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11zm7.318-19.539l-10.94 10.939"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t("contactDemo.form.actions.submit") }}</span>
              </button>
            </form>
          </div>
        </div>
        <div class="info-column">
          <div class="info-panel">
            <img alt="CNC machine in action" src="https://images.pexels.com/photos/7480234/pexels-photo-7480234.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" class="info-image"/>
            <div class="info-content">
              <h3 class="info-title">{{ $t("contactDemo.info.title") }}</h3>
              <ul class="info-list">
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>
                    {{ $t("contactDemo.info.bullets.files") }}
                  </span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>
                    {{ $t("contactDemo.info.bullets.walkthrough") }}
                  </span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>
                    {{ $t("contactDemo.info.bullets.noPressure") }}
                  </span>
                </li>
              </ul>
              <div class="info-badges">
                <span class="badge-pill">{{ $t("contactDemo.info.badges.oneClick") }}</span>
                <span class="badge-pill">{{ $t("contactDemo.info.badges.restApi") }}</span>
                <span class="badge-pill">{{ $t("contactDemo.info.badges.machinePark") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="timeline-section" class="timeline-section">
      <div class="timeline-container2">
        <h2 class="timeline-heading section-title">
          {{ $t("contactDemo.timeline.title") }}
        </h2>
        <div class="timeline-wrapper">
          <div class="timeline-grid">
            <article tabindex="0" aria-labelledby="step-1-title" class="timeline-step4">
              <div class="step-header1">
                <div class="step-badge">
                  <span class="visually-hidden1">{{ $t("contactDemo.timeline.steps.step1.ariaLabel") }}</span>
                  <span aria-hidden="true">1</span>
                </div>
                <h3 id="step-1-title" class="step-title2">{{ $t("contactDemo.timeline.steps.step1.title") }}</h3>
              </div>
              <p class="step-description1">
                {{ $t("contactDemo.timeline.steps.step1.description") }}
              </p>
            </article>
            <div aria-hidden="true" class="step-connector">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <path d="m18 15l-6-6l-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <article tabindex="0" aria-labelledby="step-2-title" class="timeline-step4">
              <div class="step-header1">
                <div class="step-badge">
                  <span class="visually-hidden1">{{ $t("contactDemo.timeline.steps.step2.ariaLabel") }}</span>
                  <span aria-hidden="true">2</span>
                </div>
                <h3 id="step-2-title" class="step-title2">{{ $t("contactDemo.timeline.steps.step2.title") }}</h3>
              </div>
              <p class="step-description1">
                {{ $t("contactDemo.timeline.steps.step2.description") }}
              </p>
            </article>
            <div aria-hidden="true" class="step-connector">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <path d="m18 15l-6-6l-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <article tabindex="0" aria-labelledby="step-3-title" class="timeline-step4">
              <div class="step-header1">
                <div class="step-badge">
                  <span class="visually-hidden1">{{ $t("contactDemo.timeline.steps.step3.ariaLabel") }}</span>
                  <span aria-hidden="true">3</span>
                </div>
                <h3 id="step-3-title" class="step-title2">{{ $t("contactDemo.timeline.steps.step3.title") }}</h3>
              </div>
              <p class="step-description1">
                {{ $t("contactDemo.timeline.steps.step3.description") }}
              </p>
            </article>
            <div aria-hidden="true" class="step-connector">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <path d="m18 15l-6-6l-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <article tabindex="0" aria-labelledby="step-4-title" class="timeline-step4">
              <div class="step-header1">
                <div class="step-badge">
                  <span class="visually-hidden1">{{ $t("contactDemo.timeline.steps.step4.ariaLabel") }}</span>
                  <span aria-hidden="true">4</span>
                </div>
                <h3 id="step-4-title" class="step-title2">{{ $t("contactDemo.timeline.steps.step4.title") }}</h3>
              </div>
              <p class="step-description1">
                {{ $t("contactDemo.timeline.steps.step4.description") }}
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>
    <section id="integrations-section" class="integrations-section">
      <div class="integrations-container1">
        <div class="integrations-left">
          <h2 class="section-title">{{ $t("contactDemo.integrations.title") }}</h2>
          <p class="section-content">
            {{ $t("contactDemo.integrations.description") }}
          </p>
          <div class="integration-badges">
            <span class="badge-outline">{{ $t("contactDemo.integrations.badges.oneClick") }}</span>
            <span class="badge-outline">{{ $t("contactDemo.integrations.badges.restApi") }}</span>
            <span class="badge-outline">{{ $t("contactDemo.integrations.badges.machinePark") }}</span>
          </div>
        </div>
        <div class="integrations-right">
          <div class="integrations-panel">
            <div class="machine-grid">
              <div class="machine-card">
                <img alt="CNC Router" src="https://images.pexels.com/photos/50691/drill-milling-milling-machine-drilling-50691.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" class="machine-image"/>
                <div class="machine-content">
                  <h3 class="machine-title">{{ $t("contactDemo.integrations.cards.router.imageAlt") }}</h3>
                  <p class="machine-brands">
                    {{ $t("contactDemo.integrations.cards.router.brands") }}
                  </p>
                  <ul class="machine-features">
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.router.features.gCode") }}</span>
                    </li>
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.router.features.optimization") }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="machine-card">
                <img alt="Nesting Systems" src="https://images.pexels.com/photos/9242907/pexels-photo-9242907.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" class="machine-image"/>
                <div class="machine-content">
                  <h3 class="machine-title">{{ $t("contactDemo.integrations.cards.nesting.title") }}</h3>
                  <p class="machine-brands">
                    <span>{{ $t("contactDemo.integrations.cards.nesting.primaryBrand") }}</span>
                    <br />
                    <br />
                    {{ $t("contactDemo.integrations.cards.nesting.brands") }}
                  </p>
                  <ul class="machine-features">
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.nesting.features.layouts") }}</span>
                    </li>
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.nesting.features.wasteReduction") }}</span>
                    </li>
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.nesting.features.staydown") }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="machine-card">
                <img alt="Panel Saws" src="https://images.pexels.com/photos/7480242/pexels-photo-7480242.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" class="machine-image"/>
                <div class="machine-content">
                  <h3 class="machine-title">{{ $t("contactDemo.integrations.cards.beamSaws.title") }}</h3>
                  <p class="machine-brands">
                    <span>{{ $t("contactDemo.integrations.cards.beamSaws.brandsLine1") }}</span>
                    <br />
                    <span>{{ $t("contactDemo.integrations.cards.beamSaws.brandsLine2") }}</span>
                    <br />
                  </p>
                  <ul class="machine-features">
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.beamSaws.features.cutLists") }}</span>
                    </li>
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.beamSaws.features.cuttingSequences") }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="machine-card">
                <img alt="Edgebanders" src="https://images.pexels.com/photos/6654800/pexels-photo-6654800.jpeg?auto=compress&amp;cs=tinysrgb&amp;h=650&amp;w=940" class="machine-image"/>
                <div class="machine-content">
                  <h3 class="machine-title">
                    {{ $t("contactDemo.integrations.cards.edgebanders.title") }}
                  </h3>
                  <p class="machine-brands"> </p>
                  <ul class="machine-features">
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.edgebanders.features.edgeProgram") }}</span>
                    </li>
                    <li>
                      <span>{{ $t("contactDemo.integrations.cards.edgebanders.features.stockMapping") }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="api-info">
              <div class="api-icon">
                <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div class="api-content1">
                <h3 class="api-title1">{{ $t("contactDemo.integrations.api.title") }}</h3>
                <p class="api-description">
                  {{ $t("contactDemo.integrations.api.description") }}
                </p>
              </div>
            </div>
            <p class="integration-footer">
              {{ $t("contactDemo.integrations.footer") }}
            </p>
          </div>
        </div>
      </div>
    </section>
    <section id="trust-contact-section" class="trust-contact-section">
      <div class="trust-contact-container">
        <div class="contact-column">
          <div class="contact-card">
            <h2 class="section-title">{{ $t("contactDemo.contact.title") }}</h2>
            <div class="contact-item2">
              <div class="contact-icon">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <div class="contact-details">
                <h3 class="contact-label1">{{ $t("contactDemo.contact.office.title") }}</h3>
                <p class="contact-text">{{ $t("contactDemo.contact.office.line1") }}</p>
                <p class="contact-text">{{ $t("contactDemo.contact.office.line2") }}</p>
              </div>
            </div>
            <div class="contact-item2">
              <div class="contact-icon">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <div class="contact-details">
                <h3 class="contact-label1">{{ $t("contactDemo.contact.phone.title") }}</h3>
                <a href="tel:+3289819330">
                  <div class="contact-link-main">
                    <span>+32 (0)89 81 93 30</span>
                  </div>
                </a>
              </div>
            </div>
            <div class="contact-item2">
              <div class="contact-icon">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                    <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                  </g>
                </svg>
              </div>
              <div class="contact-details">
                <h3 class="contact-label1">{{ $t("contactDemo.contact.email.title") }}</h3>
                <a href="mailto:info@vlecad.com">
                  <div class="contact-link-main"><span>info@vlecad.com</span></div>
                </a>
              </div>
            </div>
            <div class="contact-item2">
              <div class="contact-icon">
                <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 6v6l4 2"></path>
                    <circle r="10" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div class="contact-details">
                <h3 class="contact-label1">{{ $t("contactDemo.contact.support.title") }}</h3>
                <p class="contact-text">{{ $t("contactDemo.contact.support.hours") }}</p>
                <p class="contact-text-small"> </p>
              </div>
            </div>
            <div class="contact-badges">
              <span class="badge-filled">{{ $t("contactDemo.contact.badges.oneClick") }}</span>
              <span class="badge-filled">{{ $t("contactDemo.contact.badges.restApi") }}</span>
              <span class="badge-filled">{{ $t("contactDemo.contact.badges.machinePark") }}</span>
            </div>
          </div>
        </div>
        <div class="testimonial-column">
          <h2 class="section-title">Trusted by cabinet makers of different levels</h2>
          <div class="testimonial-grid">
            <div class="testimonial-card1 primary">
              <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24" class="quote-icon">
                <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <p class="testimonial-text2">
                Cut our setup time in half. CNC files, labels and schedules—no surprises.
              </p>
              <p class="testimonial-author1">— Jeroen V., shop owner</p>
            </div>
            <div class="testimonial-card1">
              <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24" class="quote-icon">
                <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <p class="testimonial-text2">
                Reliable hand-off from design to the floor. Fewer errors, fewer returns.
              </p>
              <p class="testimonial-author1">— Annelies D., production manager</p>
            </div>
          </div>
          <div class="support-block">
            <div class="support-icon">
              <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <div class="support-content">
              <h3 class="support-title">Local support &amp; onboarding</h3>
              <p class="support-text">
                Phone, email and remote screen share when you need it. Precision that ships on time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";

import AppNavigation from "../components/navigation";
import AppFooter from "../components/footer";
import axios from "axios";

export default {
  name: "Contactdemo",
  props: {},
  components: {
    AppNavigation,
    AppFooter,
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: "Contactdemo - KORPUS by VLECAD®",
      meta: [
        {
          name: "description",
          content:
            "KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.",
        },
        {
          property: "og:title",
          content: "Contactdemo - KORPUS by VLECAD®",
        },
        {
          property: "og:description",
          content:
            "KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.",
        },
        {
          property: "og:image",
          content:
            "https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://hospitable-imperfect-heron-qlicxu.teleporthq.app/contactdemo",
        },
      ],
    });
  },
  data() {
    return {
      baseURL: "https://my.vlecad.be/",
      form: {
        name: "",
        email: "",
        company: "",
        phone: "",
        machine_router: false,
        machine_nesting: false,
        machine_saw: false,
        machine_edgebander: false,
        machine_other: false,
        message: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      console.log("handleSubmit called");
      console.log("form: " + JSON.stringify(this.form));

      axios
        .post(this.baseURL + "api/mail/sendMailKorpusSoftware.php", this.form)
        .then((res) => {
          console.log(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log("error sendMailKorpusSoftware: " + err);
        });

      console.log("Formulier verzonden:", this.form);
      alert("Bedankt! We nemen zo snel mogelijk contact met je op.");

      return false; // Zorgt ervoor dat de pagina niet opnieuw wordt geladen
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
@keyframes heroFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes heroCtaSlide {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes heroCardFade {
  from {
    opacity: 0;
    transform: translateX(12px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes ctaPanelFade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes bannerSlide {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes integrationsFade {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes contactSlide {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes testimonialFade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
*:focus-visible {
  outline: 2px solid var(--color-outline);
  outline-offset: 2px;
}
* {
  transition: background-color var(--animation-duration-fast) var(--animation-curve-primary),
    color var(--animation-duration-fast) var(--animation-curve-primary), border-color var(--animation-duration-fast) var(--animation-curve-primary);
}
*:where(:not(:active):not(:focus):not(:hover)) {
  transition-duration: var(--animation-duration-standard);
}
</style>

<style scoped>
.contactdemo-container1 {
  width: 100%;
  display: block;
  min-height: 100vh;
}

.contactdemo-container2 {
  display: none;
}

.contactdemo-container3 {
  display: contents;
}

.contactdemo-container4 {
  display: none;
}

.contactdemo-container5 {
  display: contents;
}

.contactdemo-container6 {
  display: none;
}

.contactdemo-container7 {
  display: contents;
}

.contactdemo-thq-form-banner-elm {
  display: none;
}
</style>
